import { Droplets, Leaf, Sparkles, Clock, ShieldCheck, Beaker } from "lucide-react";

const features = [
  { icon: Droplets, title: "Senza Acqua", desc: "Fino a 150 litri risparmiati per ogni auto lavata. Il nostro metodo elimina l'uso dell'acqua." },
  { icon: Leaf, title: "100% Ecologico", desc: "Prodotti biodegradabili, zero inquinamento di suolo e falde acquifere. La scelta responsabile." },
  { icon: Sparkles, title: "Brillantezza Immediata", desc: "La formula nanotech sigilla la superficie regalando una lucentezza profonda e duratura." },
  { icon: Clock, title: "Risparmio Tempo", desc: "Wash & Go: lavaggio completo in tempi ridotti. Perfetto anche durante la giornata lavorativa." },
  { icon: ShieldCheck, title: "Igiene & Cura", desc: "Trattamenti che proteggono la vernice e igienizzano in profondità ogni superficie dell'abitacolo." },
  { icon: Beaker, title: "Formula Nanotech", desc: "Polimeri avanzati e lubrificanti incapsulano lo sporco senza graffiare la carrozzeria." },
];

export default function Features() {
  return (
    <section id="vantaggi" data-testid="features-section" className="relative py-24 md:py-32 bg-gradient-to-b from-transparent via-nexa-surface/30 to-transparent">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-px bg-nexa-blue" />
            <span className="overline">Perché Sceglierci</span>
          </div>
          <div className="heading text-3xl md:text-5xl text-white leading-tight">
            Sei vantaggi che fanno la <span className="text-nexa-blue">differenza.</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
          {features.map((f, i) => {
            const Icon = f.icon;
            return (
              <div
                key={i}
                data-testid={`feature-${i}`}
                className="bg-nexa-bg p-8 group hover:bg-nexa-surface2 transition-colors relative"
              >
                <div className="absolute top-0 left-0 h-px w-0 bg-nexa-blue group-hover:w-full transition-all duration-500" />
                <div className="mb-5">
                  <Icon size={28} className="text-nexa-blue" strokeWidth={1.5} />
                </div>
                <div className="heading text-xl text-white uppercase tracking-wider mb-3">{f.title}</div>
                <p className="text-sm text-nexa-muted leading-relaxed">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
